// 导入组件，组件必须声明 name
import yBack from "./src/index.vue";
// 为组件提供 install 安装方法，供按需引入
yBack.install = function (Vue) {
  Vue.component(yBack.name, yBack);
};
// 默认导出组件
export default yBack;